import {
  handleDeleteWebinar,
  handleRetrieveAllWebinar,
} from "../../../../../redux/specialist-slices/webinar.slice";
import { refresher } from "../../../../../redux/guest-slices/other.slice";
import SkeletonImage from "../../../../../components/ui/SkeletonImage";
import { Link as NavLink, useParams } from "react-router-dom";
import { FILE_PATH_URI } from "../../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import Icons from "../../../../../assets/js/Icons";
import moment from "moment";

import {
  Alert,
  Box,
  Button,
  Chip,
  Divider,
  Grid2 as Grid,
  IconButton,
  Link,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";

function AllWebinars() {
  const { type } = useParams();
  const dispatch = useDispatch();
  const [data, setdata] = useState({});
  const { loadings, refresh } = useSelector((state) => state.otherSlice);

  // Handle get all blogs
  const handleretrieveAll = async () => {
    const response = await dispatch(
      handleRetrieveAllWebinar({
        type,
      })
    ).unwrap();
    setdata(response);
  };

  // Handle delete webinar
  const handleDelete = async (id) => {
    await dispatch(handleDeleteWebinar(id)).unwrap();
    setTimeout(() => {
      dispatch(refresher());
    }, 500);
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, [refresh, type]);

  return (
    <Fragment>
      <Box
        sx={{
          p: 1,
          mb: 3,
          gap: 1,
          display: "flex",
          border: "1px solid",
          borderRadius: "6px",
          alignItems: "center",
          borderColor: "divider",
        }}
      >
        {["past", "pending", "upcoming"]?.map((ele, i) => (
          <Button
            disableRipple
            LinkComponent={NavLink}
            key={`${ele}-${i + 1}`}
            to={`/specialist/profile/webinars/${ele}`}
            sx={{
              textTransform: "capitalize",
              bgcolor: "transparent !important",
              color: type === ele ? "primary.main" : "other.color1",
            }}
          >
            {ele}
          </Button>
        ))}
      </Box>
      <Grid container spacing={2}>
        {loadings?.retrieveAll ? (
          new Array(4).fill().map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Skeleton
                sx={{
                  width: "100%",
                  height: "100%",
                  transform: "none",
                  aspectRatio: "1/0.5",
                }}
              />
            </Grid>
          ))
        ) : data?.records?.length === 0 ? (
          <Grid size={12}>
            <Alert
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                alignItems: "center",
                fontFamily: "Poppins",
                ".MuiAlert-message": { p: "0" },
                ".MuiAlert-icon": { fontSize: "28px" },
              }}
              color="error"
              severity="error"
            >
              No Records Found!
            </Alert>
          </Grid>
        ) : (
          data?.records?.map((element, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  gap: 1,
                  height: "100%",
                  display: "flex",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "divider",
                  flexDirection: "column",
                  transition: "all 450ms ease",
                  boxShadow: "0 0 10px 0 #0000000a",
                  ":hover": {
                    transform: "scale(1.01)",
                    boxShadow: "0 0 10px 0 #00000021",
                  },
                }}
              >
                <Box
                  to={`/specialist/profile/webinar-details/${element?._id}`}
                  component={NavLink}
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "6px",
                    aspectRatio: "1/0.6",
                  }}
                >
                  <SkeletonImage
                    src={FILE_PATH_URI + element?.details?.coverImage?.path}
                  />
                </Box>

                <Stack spacing={2} sx={{ flexGrow: 1 }}>
                  <Divider />
                  <Box
                    sx={{
                      gap: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Chip
                      color={
                        element?.status === "pending"
                          ? "warning"
                          : element?.status === "approved"
                          ? "primary"
                          : element?.status === "rejected"
                          ? "error"
                          : null
                      }
                      size="small"
                      label={
                        element?.status === "rejected"
                          ? "Revision Requested"
                          : element?.status
                      }
                      sx={{
                        fontWeight: "400",
                        fontFamily: "Poppins",
                        textTransform: "capitalize",
                      }}
                    />

                    <Stack direction="row" spacing={0.5}>
                      <IconButton
                        to={`/specialist/profile/webinar-details/${element?._id}`}
                        component={NavLink}
                        size="small"
                        sx={{ svg: { fontSize: 20 } }}
                      >
                        <Icons.ViewStrokeStandard />
                      </IconButton>
                      <IconButton
                        size="small"
                        LinkComponent={NavLink}
                        to={`/specialist/profile/webinar/${element?._id}`}
                      >
                        <Icons.EditSolid />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleDelete(element?._id);
                        }}
                      >
                        <Icons.DeleteSolid />
                      </IconButton>
                    </Stack>
                  </Box>
                  <Link
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      WebkitLineClamp: 1,
                      color: "other.color1",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      transition: "all 350ms ease",
                      ":hover": {
                        color: "primary.main",
                      },
                    }}
                    fontSize={20}
                    fontWeight="500"
                    underline="hover"
                    to={`/specialist/profile/webinar-details/${element?._id}`}
                    component={NavLink}
                  >
                    {element?.details?.title}
                  </Link>
                  <Typography
                    mt="auto !important"
                    lineHeight="1"
                    fontWeight="500"
                    component="span"
                    color="other.color2"
                  >
                    {moment(element?.schedule?.startTime).format(
                      "MMM DD YYYY [at] hh:mm A"
                    )}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Fragment>
  );
}

export default AllWebinars;
